import React from "react";
import { Box } from "@mui/material";
import Settings from "../Settings/Settings";
import SearchField from "./SearchField";

const NavBar = ({ options }) => {
  return (
    <>
      {/* <Box display="column"> */}
      <Box
        sx={{
          position: "sticky",
          top: "8px",
          maxWidth: { xs: "343px", sm: "600px" },
          margin: "auto",
          zIndex: 1,
          "&::after": {
            content: '""',
            display: "block",
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backdropFilter: "blur(12px)",
            borderRadius: "8px", // Same border radius as the main box
            zIndex: -1,
          },
          "&::before": {
            // New ::before pseudo-element
            content: '""',
            display: "block",
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            border: "1px solid #E0E0E0", // Your border
            borderRadius: "8px", // Same border radius as the main box
            zIndex: 0, // Placed above the ::after element
          },
        }}
        borderRadius={"8px"}
        boxShadow={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box pl="0px" m="0px">
          <Settings />
        </Box>
        <Box width={"100%"}>
          <SearchField options={options} />
        </Box>
      </Box>
    </>
  );
};

export default NavBar;
